"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfManagementServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
let PdfManagementService = class PdfManagementService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
        this.selectedPdfFile = null;
        this.isPdfLoading = false;
        this.pdfChapters = [];
        this.pdfContext = '';
        this.generatedFromPdf = [];
    }
    validatePdfFile(file) {
        // Validate file type
        if (!file.filename.toLowerCase().endsWith('.pdf')) {
            return { isValid: false, error: 'Please select a valid PDF file' };
        }
        // Validate file size (50MB limit for PDFs)
        const maxSize = 50 * 1024 * 1024; // 50MB
        if (file.size > maxSize) {
            return { isValid: false, error: 'PDF file size must be less than 50MB' };
        }
        return { isValid: true };
    }
    async extractChaptersFromPdf(file) {
        const result = await this.apiService.back.post('trainer.pdf.extract', { fileBuffer: file.path });
        if (!result.success) {
            throw new Error(result.error || 'Failed to extract chapters from PDF');
        }
        return {
            chapters: result.chapters || [],
            fileName: result.fileName || 'extracted.pdf'
        };
    }
    async generateTrainingDataFromPdf(fileName, context) {
        const result = await this.apiService.back.post('trainer.pdf.generate', {
            fileName,
            context
        });
        if (!result.success) {
            throw new Error(result.error || 'Failed to generate training data from PDF');
        }
        return result.trainingData || [];
    }
    async generateTrainingDataFromChapter(filePath, chapter, context) {
        const result = await this.apiService.back.post('trainer.chapter.generate', {
            filePath,
            chapter,
            context
        });
        if (result.success && result.trainingData) {
            return result.trainingData;
        }
        return [];
    }
    setPdfFile(file) {
        this.selectedPdfFile = file;
    }
    setPdfLoading(loading) {
        this.isPdfLoading = loading;
    }
    setPdfChapters(chapters) {
        this.pdfChapters = chapters;
    }
    setPdfContext(context) {
        this.pdfContext = context;
    }
    setGeneratedFromPdf(data) {
        this.generatedFromPdf = data;
    }
    resetPdfState() {
        this.selectedPdfFile = null;
        this.pdfChapters = [];
        this.pdfContext = '';
        this.generatedFromPdf = [];
        this.isPdfLoading = false;
    }
};
exports.PdfManagementServiceInstance = PdfManagementService;
exports.PdfManagementServiceInstance = PdfManagementService = __decorate([
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], PdfManagementService);
exports.default = PdfManagementService.getSingleton();
